<template>
    <v-card class="card--shadow">
        <v-card-title class="purple accent-4">
            <div class="subtitle-1 white--text">CI/HE Edit Form</div>
        </v-card-title>
        <v-card-text class="pt-4">
            <form-require-noti />
            <v-row>
            <v-col lg="6">
                <label>Date <require-sign /></label>
                <date-picker
                @clearDate="ciData.date = null"
                :validationMsg="handleFieldErrors($v.ciData.date)"
                :date="ciData.date"
                v-model="ciData.date"
                :min="minDate"
                :max="maxDate"
                />
            </v-col>
            <v-col lg="6">
                <label>Screening Person <require-sign /></label>
                <v-select
                :items="[
                    { id: '1', text: 'Volunteer' },
                    { id: '2', text: 'FO' },
                ]"
                v-model="ciData.screening_person"
                :error-messages="handleFieldErrors($v.ciData.screening_person)"
                item-text="text"
                item-value="id"
                dense
                outlined
                ></v-select>
            </v-col>
            </v-row>
            <v-row>
              <v-col lg="6">
                <label>Symptom Screening <require-sign /></label>
    
                <v-radio-group v-model="ciData.symptom_screening" row >
                    <v-radio label="Yes" value="2"></v-radio>
                    <v-radio label="No" value="1"></v-radio>
                </v-radio-group>
            </v-col>
            <v-col lg="6">
                <label>Refer <require-sign /></label>
    
                <v-radio-group v-model="ciData.refer" row >
                    <v-radio label="Yes" value="2"></v-radio>
                    <v-radio label="No" value="1"></v-radio>
                </v-radio-group>
            </v-col>
            </v-row>
            <v-card-actions >
            <v-spacer></v-spacer>
           
            <v-btn @click.prevent="emitData" :loading="loading" class="form-btn">
              <v-icon left>mdi-chevron-right-circle-outline</v-icon>Update
            </v-btn>
        </v-card-actions>
        </v-card-text>
  
    </v-card>
  </template>
  
  <script>
  import { required } from "vuelidate/lib/validators";
  import { ValidationMixin } from "../../mixins/ValidationMixin";
  import { limitDateMixin } from "../../mixins/limitDateMixin";
  import { mapState, mapActions } from "vuex";
  import FormRequireNoti from "@/components/notification/FormRequireNoti.vue";
  import RequireSign from "@/components/notification/RequireSign.vue";
  import DatePicker from "@/components/common/DatePicker.vue";
  export default {
    components: { RequireSign, FormRequireNoti, DatePicker },
    mixins: [ValidationMixin, limitDateMixin],
    props: {
      ciData: {
        type: Object,
        default: () => {
          return {
            screening_person: null,
            date: null,
            symptom_screening:null,
            presumptive_id:null,
            screening_township_id:null,
            township_id:null,
            refer:null,
        };
        },
      },
    },
    beforeMount() {
    this.ciData.date = !this.ciData.date ? this.minDate : this.ciData.date;
  },
    validations() {
      return {
        ciData: {
          date: { required },
          screening_person: { required },
          symptom_screening: { required },
          screening_township_id:{required},
          refer:{required},
        },
      };
    },
 
    methods: {
      ...mapActions("Township", ["getAllTownships"]),
    
      emitData() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          let data = {
            id: this.ciData.id,
            date: this.ciData.date,
            screening_person: this.ciData.screening_person,
            symptom_screening: this.ciData.symptom_screening,
            screening_township_id: this.ciData.screening_township_id,
            township_id: this.$route.params.township_id,
            refer:this.ciData.refer,
          };
          this.$emit("emitData", data);
        }
      },
    },
    computed: {
      ...mapState("Loading", ["loading"]),
      ...mapState("Volunteer", ["volunteers"]),
      ...mapState("HE", ["townshipVolunteers"]),
      ...mapState("Admin", ["admin"]),
      ...mapState("InfoData", ["mdrTbRegs", "typeOfTBOpt"]),
      ...mapState("Township", [ "townships"]),
    },
    
    created() {
      this.$store.dispatch(
        "Volunteer/getVolunteerByTwnId",
        this.$route.params.township_id
      );
      this.getAllTownships();
    },
  };
  </script>
  
  <style scoped></style>
  